import type { EngPrint } from '@/features/engineering/hooks';
import { isViewable3D } from '@/features/engineering/model';
import type { ModelViewerTarget } from './ModelViewerDialog';

export interface PrintSummary {
  total: number;
  finished: number;
  successes: number;
  /** 0–1, or null when nothing has finished yet. */
  successRate: number | null;
  inProgress: number;
  totalMinutes: number;
  totalGrams: number;
  totalCents: number;
}

export function summarisePrints(prints: EngPrint[]): PrintSummary {
  let finished = 0;
  let successes = 0;
  let inProgress = 0;
  let totalMinutes = 0;
  let totalGrams = 0;
  let totalCents = 0;
  for (const p of prints) {
    if (p.status === 'success' || p.status === 'failed' || p.status === 'needs_rework') finished += 1;
    if (p.status === 'success') successes += 1;
    if (p.status === 'planned' || p.status === 'printing') inProgress += 1;
    totalMinutes += p.print_time_minutes ?? 0;
    totalGrams += p.material_grams ?? 0;
    totalCents += p.cost_cents ?? 0;
  }
  return {
    total: prints.length,
    finished,
    successes,
    successRate: finished > 0 ? successes / finished : null,
    inProgress,
    totalMinutes,
    totalGrams,
    totalCents,
  };
}

/** Viewer target for the exact version that was printed, when it's a format we can open. */
export function printViewerTarget(print: EngPrint): ModelViewerTarget | null {
  if (!print.version || !print.file) return null;
  if (!isViewable3D(print.version.file_name)) return null;
  return {
    storagePath: print.version.storage_path,
    fileName: print.version.file_name,
    title: print.file.name,
    subtitle: `v${print.version.version_no} · printed for “${print.title}”`,
  };
}
